import { useCallback } from 'react';

import config from 'config';

export const useOpenNewLocatorProWindow = () => {
  const openNewLocatorProWindow = useCallback(() => {
    if (config.locatorPro) {
      window.open(config.locatorPro, '_blank', 'noopener,noreferrer');
    }
  }, []);

  return openNewLocatorProWindow;
};
